const imageTypes = ['jpg', 'jpeg', 'png']
const videoTypes = ['mp4']

export const modelMedia = (data) => {
  if (!data) return {}

  let type
  if (imageTypes.includes(data.format)) type = 'image'
  if (videoTypes.includes(data.format)) type = 'video'

  return {
    src: data.src,
    alt: data.alt,
    format: data.format,
    focalPoint: data.focalPoint,
    type,
    isImage: type === 'image',
    isVideo: type === 'video',
    height: data.height,
    width: data.width,
    video: data.video,
    thumbhash: data.thumbhash
  }
}
